module.exports = __webpack_public_path__ + "media/images/logo/payment_channel/wallet_ovo-e14a44090bf335623f46a8e275dbd26d.svg";